// IMPORTANT: otel-web MUST be the very first import — DocumentLoadInstrumentation
// needs to register before window.load fires to capture the full initial page-load trace.
import './otel-web';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { warmupBackend } from './lib/warmup';
import './index.css';

import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
// Vite only exposes client env vars prefixed with VITE_.
const sentryDsn = (import.meta.env.VITE_SENTRY_DSN as string | undefined)?.trim();
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.1,
    environment: import.meta.env.MODE,
  });
}

// 在 React 挂载前同步触发 —— Render Free / Neon Free 休眠场景下，
// Splash 渲染（~500 ms）与后端唤醒（~1–3 s 至 ~30 s）并行，
// 显著减少用户感知到的"首屏卡顿"。详见 docs/deployment/cost-optimized.md §3.1。
warmupBackend();

const container = document.getElementById('root');
if (!container) throw new Error('[mini-app] #root not found in index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
